const REC_601_R = 0.3;
const REC_601_G = 0.59;
const REC_601_B = 0.11;

/**
 * Convert RGBA ImageData to grayscale using Rec. 601 luma.
 * Weights (0.3 R / 0.59 G / 0.11 B) match the Adobe PDF spec Lum function used
 * by Photoshop's Color blend mode: overlaying a desaturated copy of an image
 * in Color blend mode yields the same per-pixel value this function computes.
 * Compared to Rec. 709 (0.2126 / 0.7152 / 0.0722), Rec. 601 keeps more
 * contrast between saturated hues - saturated blue stays distinguishable from
 * black instead of collapsing to ~18.
 * Output remains RGBA with R=G=B=luma; alpha is preserved.
 */
export function toGrayscale(input: ImageData): ImageData {
  const out = new ImageData(input.width, input.height);
  const src = input.data;
  const dst = out.data;
  for (let i = 0; i < src.length; i += 4) {
    const r = src[i] ?? 0;
    const g = src[i + 1] ?? 0;
    const b = src[i + 2] ?? 0;
    const a = src[i + 3] ?? 255;
    const luma = Math.round(REC_601_R * r + REC_601_G * g + REC_601_B * b);
    dst[i] = luma;
    dst[i + 1] = luma;
    dst[i + 2] = luma;
    dst[i + 3] = a;
  }
  return out;
}
